export interface RawInwardReq {
  order_id: number;
  product_id: number;
  po_id: number;
  raw_inward_received_qty: number;
  raw_inward_mark_received?: boolean;
}

export interface RawInwardQcReq {
  order_id: number;
  product_id: number;
  po_id: number;
  raw_inward_id: number;
  raw_inward_qc_rejected_recieved_qty?: number;
  raw_inward_rejection_reason?: string;
  raw_inward_qc_images?: string[];
  raw_inward_qc_on_hold?: boolean;
  raw_inward_qc_reason_for_hold?: string | null;
}

export interface PrintOutwardReq {
  order_id: number;
  product_id: number;
  po_id: number;
  raw_inward_id: number;
  printer_id: number;
  print_outward_quantity: number;
  storage_id?: string[];
  print_outward_timeline: Date;
}

export interface PrintInwardReq {
  order_id: number;
  product_id: number;
  po_id: number;
  print_outward_id: number;
  print_inward_quantity: number;
  print_inward_mark_received?: boolean;
}

export interface PrintInwardQcReq {
  order_id: number;
  product_id: number;
  po_id: number;
  print_inward_id: number;
  print_inward_rejection_quantity?: number;
  print_inward_rejection_reason?: string;
  print_inward_qc_images?: string[];
  print_inward_qc_on_hold?: boolean;
  print_inward_qc_reason_for_hold?: string | null;
}
export interface RawInwardTimelineReq {
  order_id: number;
  product_id: number;
  purchase_requests: {
    pr_id: number;
    expected_delivery_date: string;
  }[];
}
export interface PrintInwardTimelineReq {
  order_id: number;
  product_id: number;
  raw_inwards: {
    raw_inward_id: number;
    timeline: string;
    po_id: number;
  }[];
}

export interface RawInwardDetailsReq {
  order_id: number;
  product_id: number;
  po_id: number;
  raw_inward_id?: number;
  raw_inward_qc_rejected_recieved_qty?: number;
  raw_inward_rejection_reason?: string;
  raw_inward_qc_images?: string[];
  raw_inward_qc_on_hold?: boolean;
  raw_inward_qc_reason_for_hold?: string | null;

  raw_inward_received_qty?: number;
  raw_inward_mark_received?: boolean;

  warehouse_id?: string | null;
}

export interface PrintInwardDetailsReq {
  order_id: number;
  product_id: number;
  po_id: number;
  print_inward_id?: number;
  print_inward_rejection_quantity?: number;
  print_inward_rejection_reason?: string;
  print_inward_qc_images?: string[];
  print_inward_qc_on_hold?: boolean;
  print_inward_qc_reason_for_hold?: string | null;

  print_outward_id?: number;
  print_inward_quantity?: number;
  print_inward_mark_received?: boolean;
}

export enum VendorInvoiceStatus {
  PAID = "paid",
  PARTIAL_PAID = "partial_paid",
  PENDING = "pending",
}

export enum VendorInvoiceType {
  RAW_INWARD = "raw_inward",
  PRINT_INWARD = "print_inward",
}

export interface VendorInvoice {
  serial_number?: number;
  id?: number;
  type: VendorInvoiceType;
  inward_id: number;
  invoice_number?: string;
  invoice_date?: Date;
  invoice_url?: string;
  files?: File[] | null;
  invoice_status?: VendorInvoiceStatus;
  created_by: number;
  created_by_name?: string;
  updated_by?: number;
  updated_by_name?: string;
  created_date?: Date;
  modified_date?: Date;
}
